import CheckmarkIcon from '../assets/green-checkmark.svg';

const DATA_GROUPS: { label: string; items: string[] }[] = [
  {
    label: 'Student data',
    items: ['Student roster(s)', 'Student demographics', 'Transcripts', 'Test scores'],
  },
  {
    label: 'School and program context',
    items: ['CTE Pathways', 'Course catalog(s)', 'Information on the EOAA'],
  },
  {
    label: 'Qualitative data',
    items: ['Focus group information', 'Survey information', 'Artifacts from student journey workshops'],
  },
];

const ChatDataPanel = () => (
  <div className="chat-bottom-column">
    <div className="chat-panel-heading">
      <h2 className="chat-panel-title">Data sources</h2>
      <p className="chat-panel-subtitle">XQ&apos;s custom technology safely accesses a secure database.</p>
    </div>
    <div className="chat-data-groups">
      {DATA_GROUPS.map(({ label, items }) => (
        <div key={label} className="chat-data-group">
          <p className="chat-data-group-label">{label}</p>
          <ul className="chat-data-list">
            {items.map((item) => (
              <li key={item} className="chat-data-item">
                <img src={CheckmarkIcon} alt="" aria-hidden="true" className="chat-data-item-icon" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </div>
);

export default ChatDataPanel;
